import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY,
  SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY_CREATE,
  SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY_TYPES,
} from '../main.api';
import { Cart, CashbookEntry, CashbookEntryType } from '@softapps/wws/pos-core';

@Injectable()
export class CashbookRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async getTypes(): Promise<CashbookEntryType[]> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY_TYPES,
    });
  }

  async create(cartId: number, payload: Partial<CashbookEntry>): Promise<Cart> {
    return this.#dataAccess.create(
      {
        path: SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY_CREATE,
        pathParams: {
          cartId,
        },
      },
      payload
    );
  }

  async update(cartId: number, changes: Partial<CashbookEntry>): Promise<Cart> {
    return this.#dataAccess.patch(
      {
        path: SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY,
        pathParams: {
          cartId,
          id: changes.id,
        },
      },
      changes
    );
  }

  async remove(cartId: number, id: number): Promise<Cart> {
    return this.#dataAccess.delete({
      path: SOFTLINE_API_CASH_REGISTER_CASHBOOK_ENTRY,
      pathParams: {
        cartId,
        id,
      },
    });
  }
}
